import * as React from 'react';

// bernie
import { LocalizedText } from 'bernie-l10n';

import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkPill } from 'uitk-react-pill';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';

interface ProgramsFiltersProps {
  onGroupChange?: any;
  groupBy: string;
}

export const ProgramsFilters: React.FunctionComponent<ProgramsFiltersProps> = ({ onGroupChange, groupBy }) => {
  return (
    <div className="ProgramsPage__nav">
      <UitkSpacing margin={{ blockend: 'six' }} className="container">
        <UitkLayoutFlex alignItems="center">
          <UitkSpacing margin={{ inlineend: 'three' }}>
            <UitkText size={200} weight={'bold'}>
              <LocalizedText message="programs.filters.label.group_by" />
            </UitkText>
          </UitkSpacing>
          <nav>
            <UitkPill id="posa-group" active={groupBy === 'posa'} onChange={() => onGroupChange('posa')}>
              <LocalizedText message="programs.filters.pill.point_of_sale" />
            </UitkPill>
            <UitkPill id="brand-group" active={groupBy === 'brand'} onChange={() => onGroupChange('brand')}>
              <LocalizedText message="programs.filters.pill.brand" />
            </UitkPill>
          </nav>
        </UitkLayoutFlex>
      </UitkSpacing>
    </div>
  );
};
